import { ref, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from '$/stores'
import { useToolStore } from '$/stores/tools'
import { getCurrentFeatureSlug } from '$/utils'

export function useToolSetup() {
  const route = useRoute()
  const router = useRouter()
  const store = useStore()
  const toolStore = useToolStore()
  const ready = ref(false)

  onMounted(() => {
    toolStore.fetchTool(getCurrentFeatureSlug()).finally(() => {
      ready.value = true
    })
  })

  return { route, router, store, toolStore, ready }
}
